import { Typography } from '@mui/material';

/**
 * Pure UI component for the "Next" badge
 * Displayed on the first/upcoming appointment
 */
export const NextBadge = () => {
  return (
    <Typography
      component="span"
      sx={{
        fontWeight: 500,
        color: 'inherit',
        fontSize: '0.875rem',
        opacity: 0.9,
        mr: 1,
      }}
    >
      Next
    </Typography>
  );
};
